import React from 'react';
import { LogoWithText } from '../Logos';
import { withWebAssetsTheme } from '../../theme';
import useStyles from './useErrorPageStyles';

export type HttpErrorPageProps = {
  children?: React.ReactNode;
};

export function HttpErrorPage({
  children,
}: HttpErrorPageProps): React.ReactElement {
  const { pageContainer, childrenContainer, pageLogoLink } = useStyles();
  const logoLinkId = 'HttpErrorPage_Logo_Link';
  return (
    <div className={pageContainer}>
      <a href="/" data-testid={logoLinkId} className={pageLogoLink}>
        <LogoWithText />
      </a>
      <div className={childrenContainer}>{children}</div>
    </div>
  );
}

export const withHttpErrorPage = <T extends object>(
  Component: React.ComponentType<T>,
  defaultComponentProps?: Omit<T, 'children'>
) => (props: T) => {
  const componentProps = {
    ...defaultComponentProps,
    ...props,
  };
  return (
    <HttpErrorPage>
      <Component {...componentProps} fullscreen={false} />
    </HttpErrorPage>
  );
};

export default withWebAssetsTheme(HttpErrorPage);
